import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo-centrao.png';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      await login(username, senha);
      navigate('/dashboard');
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #4A1F40 0%, #6B2C5C 50%, #7D3A6D 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: 420, padding: '0 16px' }}>
        <div className="card p-4 p-md-5">
          <div className="text-center mb-4">
            <img src={logo} alt="Centrão Materiais de Construção" style={{ width: 180, height: 'auto', marginBottom: 16 }} />
            <h4 style={{ color: '#6B2C5C', fontWeight: 700, marginBottom: 2 }}>Sistema de Marketing</h4>
            <p style={{ color: '#999', fontSize: '0.82rem', margin: 0 }}>Gestão de Campanhas Promocionais</p>
          </div>

          {erro && <div className="alert alert-danger py-2 px-3" style={{ fontSize: '0.85rem' }}>{erro}</div>}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fw-semibold" style={{ fontSize: '0.85rem' }}>Usuário</label>
              <input type="text" className="form-control" placeholder="seu.usuario"
                value={username} onChange={e => setUsername(e.target.value)} required autoFocus />
            </div>
            <div className="mb-4">
              <label className="form-label fw-semibold" style={{ fontSize: '0.85rem' }}>Senha</label>
              <input type="password" className="form-control" placeholder="••••••••"
                value={senha} onChange={e => setSenha(e.target.value)} required />
            </div>
            <button type="submit" className="btn w-100 fw-semibold"
              style={{ background: '#6B2C5C', color: '#fff', border: 'none', padding: '10px' }}
              disabled={loading}>
              {loading ? <><span className="spinner-border spinner-border-sm me-2" />Entrando...</> : 'Entrar'}
            </button>
          </form>

          <div className="text-center mt-3" style={{ color: '#bbb', fontSize: '0.72rem' }}>
            Centrão Materiais de Construção
          </div>
        </div>
      </div>
    </div>
  );
}
